import { Injectable } from '@angular/core';
import { GroupService } from 'src/app/users/+users/add-user/shared/providers/group.service';
import { PeopleService } from 'src/app/users/+users/see-users/shared/services/people.service';
import { User } from 'src/shared/models/user.class';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';
import { V2nodeApiService } from 'src/shared/services/v2node-api.service';
import { HttpHeaders } from '@angular/common/http';

export interface IAccountCreation {
  username: string,
  firstName: string,
  lastName: string,
  email: string,
  adress: {
    city: string,
    region: string,
    country: string,
    postalCode: string
  },
  phone: string,
  password: string,
  isExternal: boolean,
  etape: any,
  responsable: string
}

@Injectable({
  providedIn: 'root'
})
export class ConsultantsService {
  private endpoint = '/consultant/sheet';
  private endpointSkills = '/consultant/skills';
  private endpointRoles = '/consultant/roles';
  private endpointLanguage = '/consultant/Language';
  private endpointPublic = '/public/consultants';

  constructor(private v2nodeApi: V2nodeApiService, private peopleService: PeopleService, private groupService: GroupService) { }

  public createAccount(accoundData: IAccountCreation, isPublic = false) {
    let route = '/register/createAccount';

    if (isPublic) {
      route = `${this.endpointPublic}/register`;
    }
    return this.v2nodeApi.requestApi({ action: route, method: 'POST', datas: accoundData, customUrl: 'v2node/' });
  }

  public async getConsultantsAccounts(): Promise<any[]> {

    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/users`, method: 'GET' });
  }

  public async getConsultantsAccountsByFilters(filters): Promise<any[]> {
    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/users/filters`, method: 'POST', datas: { filters } });
  }

  public async getConsultant(idConsultant: string, asPublic = false): Promise<User> {
    const action = asPublic ? `${this.endpointPublic}/${idConsultant}` : `${this.endpoint}/getSheetByUser/${idConsultant}`;
    const customUrl = asPublic ? 'v2node' : '';
    const consultantInfos = await this.v2nodeApi.requestApi({ action, customUrl });

    let user: any;
    if (!asPublic) {
      user = await this.peopleService.getOnePeople(idConsultant);
    } else {
      user = {
        consultantSheet: consultantInfos.consultantSheet
      }
    }

    user.consultantSheet = consultantInfos.consultantSheet;
    delete consultantInfos.consultantSheet
    user.infosConsultant = consultantInfos

    return user;
  }

  public async alffectSheetToUser(datas) {
    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/alffectSheetToUser`, method: 'POST', datas });
  }
  public deleteMission(consultantSheetId, id: string) {
    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/removeMission/${consultantSheetId}/${id}`, method: 'DELETE' });
  }

  public deleteAction(consultantSheetId, id: string) {
    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/removeAction/${consultantSheetId}/${id}`, method: 'DELETE' });
  }

  public deleteCertification(consultantSheetId, id: string) {
    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/removeCertification/${consultantSheetId}/${id}`, method: 'DELETE' });
  }
  public deleteFormation(consultantSheetId, id: string) {
    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/removeFormation/${consultantSheetId}/${id}`, method: 'DELETE' });
  }


  //skills
  public getAllSkills() {
    return this.v2nodeApi.requestApi({ action: `${this.endpointSkills}/getSkills`, method: 'GET' });
  }

  public getSkill(idSkill) {

    return this.v2nodeApi.requestApi({ action: `${this.endpointSkills}/getSkill/${idSkill}`, method: 'GET' });
  }

  public updateSkill(idSkill, content: {title: string, isImportantSkill: boolean}) {

    return this.v2nodeApi.requestApi({ action: `${this.endpointSkills}/editSkill/${idSkill}`, method: 'PUT', datas: content });
  }



  public addNewSkill(title: string) {
    return this.v2nodeApi.requestApi({ action: `${this.endpointSkills}/createSkill`, method: 'POST', datas: { title } });
  }

  public deleteSkill(id: string) {
    return this.v2nodeApi.requestApi({ action: `${this.endpointSkills}/deleteSkill/${id}`, method: 'DELETE' });
  }

  //Language

  public getAllLanguage() {
    return this.v2nodeApi.requestApi({ action: `${this.endpointLanguage}/getAllLanguage`, method: 'GET' });
  }

  public getLanguagebyid(idLanguage) {

    return this.v2nodeApi.requestApi({ action: `${this.endpointLanguage}/getLanguagebyid/${idLanguage}`, method: 'GET' });
  }

  public updateLanguage(idLanguage, title) {

    return this.v2nodeApi.requestApi({ action: `${this.endpointLanguage}/updateLanguage/${idLanguage}`, method: 'PUT', datas: { title } });
  }







  public addNewLanguage(title: string) {
    return this.v2nodeApi.requestApi({ action: `${this.endpointLanguage}/addLanguage`, method: 'POST', datas: { title } });
  }

  public deleteLanguage(id: string) {
    return this.v2nodeApi.requestApi({ action: `${this.endpointLanguage}/deleteLanguage/${id}`, method: 'DELETE' });
  }

  //roles
  public updateRole(idRole, title) {
    return this.v2nodeApi.requestApi({ action: `${this.endpointRoles}/editRole/${idRole}`, method: 'PUT', datas: { title } });

  }
  public deleteRole(id: string) {
    return this.v2nodeApi.requestApi({ action: `${this.endpointRoles}/deleteRole/${id}`, method: 'DELETE' });
  }

  public getAllRoles() {
    return this.v2nodeApi.requestApi({ action: `${this.endpointRoles}/getRoles`, method: 'GET' });
  }

  public addNewJobTitle(title: string) {
    return this.v2nodeApi.requestApi({ action: `${this.endpointRoles}/createRole`, method: 'POST', datas: { title } });
  }

  public loadJobTitlesByName = (title: string) => {
    if (!title) {
      return [];
    }

    return this.v2nodeApi.requestApi({ action: `${this.endpointRoles}/getRolesByName`, method: 'POST', datas: { searchTerm: title } });
  }

  public loadSkillsByName = (title: string) => {
    if (!title) {
      return [];
    }

    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/getSkillsByName`, method: 'POST', datas: { searchTerm: title } });
  }

  public getImportantSkills() {
    return this.v2nodeApi.requestApi({ action: `${this.endpointSkills}/getImportantSkills`, method: 'GET' });
  }

  public updateProfile({ idConsultant, profile = {}, consultantSheet = {} }: { idConsultant: string, profile?: any, consultantSheet?: any }) {
    const datas = { profile, consultantSheet };

    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/updateProfile/${idConsultant}`, method: 'PUT', datas });
  }

  public getCV(idConsultant) {
    return this.v2nodeApi.requestApi({ action: `${this.endpointPublic}/getCVPDF/${idConsultant}`, customUrl: 'v2node', httpOptions: { responseType: 'blob' as 'json' } })
  }

  public deleteContultants(consultantIds) {


    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/deleteConsultants`, method: 'DELETE', datas: { usersIds: consultantIds } });
  }

  public updateProfileByLinkedin({ idConsultant }: { idConsultant: string }) {
    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/updateByLinkedin/${idConsultant}`, method: 'GET' });
  }

  public updateImmediatlyProfileByLinkedin({ idConsultant }: { idConsultant: string }) {
    return this.v2nodeApi.requestApi({ action: `${this.endpoint}/updateImmediatlyByLinkedin/${idConsultant}`, method: 'GET' });
  }

  public sendEmail(data) {
    let route = "api/consultant/sheet/createAccountInvitation";
    return this.v2nodeApi.requestApi({ action: route, method: 'POST', httpOptions: { responseType: 'text' }, datas: data, customUrl: 'v2node/' });
  }
}
